import { render, staticRenderFns } from "./LogInPaper.vue?vue&type=template&id=49adab94&scoped=true&"
import script from "./LogInPaper.vue?vue&type=script&lang=js&"
export * from "./LogInPaper.vue?vue&type=script&lang=js&"
import style0 from "./LogInPaper.vue?vue&type=style&index=0&id=49adab94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49adab94",
  null
  
)

export default component.exports